export default function getStyle() {
  return {
    label: {
      paddingRight: 6
    },
    input: {
      marginRight: 4
    }
  };
};